export default __webpack_public_path__ + "static/media/skyniche-logo.962a8d83.png";